import { SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE } from './constants';

const defaultState = {
    solarInputsToggle: false,
};

const solarInputsUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE:
            return { ...state, solarInputsToggle: action.solarInputsToggle };

        default:
            return state;
    }
};

export default solarInputsUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SolarInputs/reducer.js